import { OverlayBanner } from '@/components/shared/OverlayBanner';
import { VoiCreationControlsOverlay } from './VoiCreationControlsOverlay';
import { Typography } from '@mui/material';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { useAtomValue } from 'jotai';
import * as poiState from '../../state';
import * as cuboidState from '../../../cuboids';
import { useMemo } from 'react';
import { PointOfInterestTemplateTypeEnum } from '@/__generated__/graphql';
import { viewerCurrentSpherical } from '@/components/Analysis/state';

const InitialHintOverlay = () => {
  const currentSpherical = !!useAtomValue(viewerCurrentSpherical);

  return (
    <OverlayBanner
      sx={{ mb: 2, py: 2, px: 3 }}
      icon={<AbyssIcon iconName="cuboid-yellow" size="lg" />}
    >
      <Typography variant="body1" sx={{ whiteSpace: 'nowrap' }}>
        Select the first <strong>point</strong> in the 3D view to create a VOI
        {!currentSpherical && (
          <>
            , or choose <strong>Spherical</strong> to switch to Image View and place the point.
          </>
        )}
      </Typography>
    </OverlayBanner>
  );
};

const ResizingHintOverly = () => (
  <OverlayBanner
    sx={{ mb: 2, py: 2, px: 3 }}
    icon={<AbyssIcon iconName="cuboid-yellow" size="lg" />}
  >
    <Typography variant="body1" sx={{ whiteSpace: 'nowrap' }}>
      Select the <strong>bounding box</strong> if you want to resize the VOI.
    </Typography>
  </OverlayBanner>
);

export const VoiCreationHintsOverlay = () => {
  const editPointOfInterest = useAtomValue(poiState.editPointOfInterest);
  const isCuboidEditorEnabled = useAtomValue(cuboidState.isCuboidEditorEnabled);
  const state = useMemo(() => editPointOfInterest.state, [editPointOfInterest.state]);

  const show = useMemo(() => {
    if (editPointOfInterest.template?.type !== PointOfInterestTemplateTypeEnum.VolumeOfInterest) {
      return false;
    }
    if (state === 'WaitingForTransition') return false;

    return true;
  }, [state, editPointOfInterest.template?.type]);
  if (!show) return <></>;
  if (editPointOfInterest.formState === 'Create') return <></>;

  if (
    editPointOfInterest.formState === 'Update-General' ||
    editPointOfInterest.formState === 'Update-Template' ||
    editPointOfInterest.formState === 'Verify'
  )
    return <ResizingHintOverly />;

  // Show the initial hint overlay
  if (state === 'WaitingForPoint') return <InitialHintOverlay />;

  // Show the controls if the cuboid is being edited
  if (isCuboidEditorEnabled) return <VoiCreationControlsOverlay />;

  return <></>;
};
